<div class="page-404">
  <!-- Background -->
  <div class="background-elements">
    <span class="circle circle-1"></span>
    <span class="circle circle-2"></span>
    <span class="circle circle-3"></span>
    <span class="grid-pattern"></span>
  </div>

  <!-- Error Card -->
  <div class="error-card">
     <div class="brand-logo">
      <img src="/images/logo.png" alt="VETA Investment Partners Logo" />
    </div>
    

    <div class="error-code">
      <span>4</span>
      <span class="zero">
        <i class="fa-solid fa-compass"></i>
      </span>
      <span>4</span>
    </div>

    

    <h1>Oops! Page Not Found</h1>

    <p>The page you're looking for doesn't exist, has been moved, or the URL may be incorrect.</p>

    <div class="error-actions">
      <button nz-button nzType="primary" class="home-btn" (click)="handleNavigate()">
        <i class="fa-solid fa-house"></i>
        Home
      </button>

      <button nz-button class="back-btn" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
        Go Back
      </button>
    </div>

    <div class="help-text">
      <i class="fa-regular fa-circle-question"></i>
      Please check the URL and try again.
    </div>
  </div>
</div>
